module.exports = __webpack_public_path__ + "media/images/cog-f7148f484796ba260031905f41ff8cbc.svg";